/**
 * @generated SignedSource<<add373dbf3ca373f2386c7db73783dd0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "globalVariable"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "globalVariableId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "globalVariable",
        "variableName": "globalVariable"
      },
      {
        "kind": "Variable",
        "name": "globalVariableId",
        "variableName": "globalVariableId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "updateGlobalVariable",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateGlobalVariableMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateGlobalVariableMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7a9d633fdffa3d505046833f01c204db",
    "id": null,
    "metadata": {},
    "name": "UpdateGlobalVariableMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateGlobalVariableMutation(\n  $globalVariableId: ID!\n  $globalVariable: GlobalVariableInput!\n) {\n  updateGlobalVariable(globalVariableId: $globalVariableId, globalVariable: $globalVariable) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "e89ca97e4264d4c728ff2f6d3ef87068";

export default node;
